import { render, staticRenderFns } from "./CampaignUserView.vue?vue&type=template&id=e4c068cc&scoped=true&"
import script from "./CampaignUserView.vue?vue&type=script&lang=js&"
export * from "./CampaignUserView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignUserView.vue?vue&type=style&index=0&id=e4c068cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c068cc",
  null
  
)

export default component.exports